import { AbstractControl, ValidationErrors } from '@angular/forms';
import { ValidationIssue } from '../trip-calculator/types/validation';

export function addressValidator(issues: ValidationIssue[]) {
  return (control: AbstractControl): ValidationErrors | null => {
    const address = control.value;

    if (!address) return null;
    
    const hasIssue = issues.some(
      (issue) =>
        issue.code === 'TRANSPORT_ADDRESS_INVALID' &&
        issue.context?.['address'] === address,
    );
    return hasIssue ? { invalidAddress: true } : null;
  };
}
